<template>
  <div class="ai-typing">
    <span class="typing-dots"><i></i><i></i><i></i></span>
    <span class="typing-phase">{{ phase }}</span>
  </div>
</template>

<script>
export default {
  name: 'AiTypingIndicator',
  props: {
    phase: { type: String, default: 'думает…' },
  },
};
</script>

<style scoped>
.ai-typing {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 2px;
  color: #6b7280;
  font-size: 12.5px;
}
.typing-dots {
  display: inline-flex;
  gap: 4px;
}
.typing-dots i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  opacity: 0.45;
  animation: ai-typing-pulse 1.2s infinite ease-in-out;
}
.typing-dots i:nth-child(2) { animation-delay: 0.2s; }
.typing-dots i:nth-child(3) { animation-delay: 0.4s; }
@keyframes ai-typing-pulse {
  0%, 80%, 100% { opacity: 0.25; transform: scale(0.85); }
  40% { opacity: 1; transform: scale(1.1); }
}
</style>
